<template></template>

<script>
import UserSettingsService from '../service/UserSettingsService';

export default {
  name: 'HomePlaceholder',
  beforeCreate() {
    this.$router.push('/' + UserSettingsService.getStartingPage().toLowerCase());
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HomePlaceholder.vue